<script>
  // See https://andrejgajdos.com/custom-select-dropdown/
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  let mobileOpen = false;

  export let panes;
  export let currentPane;

  const handleToggleOpen = () => {
    mobileOpen = !mobileOpen;
  };

  const handleSelect = (pane) => {
    dispatch("change", pane);
  };

  $: currentPaneLabel = currentPane ? currentPane.label : "";
</script>

<div
  class={`custom-select-wrapper ${mobileOpen ? "open" : ""}`}
  on:click={handleToggleOpen}
>
  <div class="custom-select__trigger">
    <span>{currentPaneLabel}</span>
    <div class="arrow" />
  </div>
  <div class="custom-options">
    {#each panes as pane (pane.relUrl)}
      <div
        class={`custom-option ${currentPane == pane ? "active" : ""}`}
        on:click={() => {
          handleSelect(pane);
        }}
      >
        {pane.label}
      </div>
    {/each}
  </div>
</div>

<style>
  .custom-select-wrapper {
    position: relative;
    user-select: none;
    width: 100%;
  }

  .custom-select__trigger {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 22px;
    font-size: 20px;
    font-weight: 300;
    color: black;
    height: 60px;
    line-height: 60px;
    background: #fff;
    cursor: pointer;
    border: 1px solid black;
  }

  .custom-options {
    position: absolute;
    display: block;
    top: 100%;
    left: 0;
    right: 0;
    border: 1px solid black;
    border-top: 0;
    background: #fff;
    transition: all 0.3s;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 2;
  }

  .custom-select-wrapper.open .custom-options {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
  }

  .custom-select-wrapper :global(.custom-option) {
    position: relative;
    display: block;
    padding: 0 22px 0 22px;
    font-size: 22px;
    font-weight: 300;
    line-height: 60px;
    cursor: pointer;
    transition: all 0.5s;
  }

  .custom-select-wrapper :global(.custom-option:hover) {
    cursor: pointer;
    background-color: #b2b2b2;
  }

  .custom-select-wrapper :global(.custom-option.active) {
    color: #ffffff;
    background-color: var(--accent);
  }

  /* Arrow */
  .arrow {
    position: relative;
    height: 15px;
    width: 15px;
  }
  .arrow::before,
  .arrow::after {
    content: "";
    position: absolute;
    bottom: 0px;
    width: 0.15rem;
    height: 100%;
    transition: all 0.3s;
  }
  .arrow::before {
    left: -5px;
    transform: rotate(45deg);
    background-color: #394a6d;
  }
  .arrow::after {
    left: 5px;
    transform: rotate(-45deg);
    background-color: #394a6d;
  }
  .open .arrow::before {
    left: -5px;
    transform: rotate(-45deg);
  }
  .open .arrow::after {
    left: 5px;
    transform: rotate(45deg);
  }
</style>
